import { render, staticRenderFns } from "./myAboutList.vue?vue&type=template&id=59585c3e&scoped=true&"
import script from "./myAboutList.vue?vue&type=script&lang=js&"
export * from "./myAboutList.vue?vue&type=script&lang=js&"
import style0 from "./myAboutList.vue?vue&type=style&index=0&id=59585c3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59585c3e",
  null
  
)

export default component.exports